let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("Bh1ku")).then(() => parcelRequire('hS26u'));